export enum GrowthSignalDateFilterValuesEnum {
    LAST_30_DAYS = 'LAST_30_DAYS',
    LAST_90_DAYS = 'LAST_90_DAYS',
    LAST_180_DAYS = 'LAST_180_DAYS',
    CUSTOM = 'CUSTOM',
}
